import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-general-label',
	templateUrl: './general-label.component.html',
	styleUrls: ['./general-label.component.scss'],
})
export class GeneralLabelComponent implements OnInit {
	constructor(
		private LabelsService: LabelsService,
		private ProfileService: ProfileService,
		private NotificationService: NotificationService
	) {}

	labels: LabelsInterface = {
		lbl_geral_portugues: '',
		lbl_geral_ingles: '',
		lbl_geral_espanhol: '',
		lbl_geral_eslovaco: '',
		lbl_geral_chines: '',
		lbl_geral_italiano: '',
		lbl_iac_min_char_search: '',
		lbl_geral_nome: '',
		lbl_geral_atualizar: '',
		lbl_geral_registrar: '',
		lbl_criar_novo_item: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_geral_limpar_campos: '',
		lbl_preencha_todos_campos: '',
		lbl_successful_updated: '',
	};
	labelLoad: LabelsInterface[] = [];
	labelLoadIAC: iacOptionInterface[] = [];

	isLoadingLabels = true;
	isLoadingLabelLoad = true;

	isCreatingLabel = false;
	isUpdatingLabel = false;

	selectedLabel: LabelsInterface = {
		id: '-1',
		portuguese: '',
		english: '',
		spanish: '',
		slovak: '',
		chinese: '',
		italian: '',
	};

	crudType: 'update' | 'create';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.LabelsService.getLabelLoad().subscribe((labelLoad) => {
			this.labelLoad = labelLoad;

			for (const label of this.labelLoad) {
				const labelIAC: iacOptionInterface = {
					name: label.id,
					secondName: label[this.ProfileService.userData().language],
					value: label.id,
					commonGroup: label[this.ProfileService.userData().language],
				};

				this.labelLoadIAC.push(labelIAC);
			}

			this.isLoadingLabelLoad = false;
		});
	}

	setLabel(label?: string): void {
		if (this.isCreatingLabel || this.isUpdatingLabel) return;

		if (label) {
			this.labelLoad.find((labels) => {
				if (labels.id === label) {
					this.selectedLabel = labels;
					this.crudType = 'update';
				}
			});
		} else {
			this.selectedLabel = {
				id: '',
				portuguese: '',
				english: '',
				spanish: '',
				slovak: '',
				chinese: '',
				italian: '',
			};

			this.crudType = 'create';
		}
	}

	isAllFieldsFullfiled(): boolean {
		return (
			this.selectedLabel.id != '' &&
			this.selectedLabel.portuguese != '' &&
			this.selectedLabel.english != '' &&
			this.selectedLabel.spanish != '' &&
			this.selectedLabel.slovak != '' &&
			this.selectedLabel.chinese != '' &&
			this.selectedLabel.italian != ''
		);
	}

	createLabel(): void {
		if (this.isCreatingLabel) return;

		if (!this.isAllFieldsFullfiled()) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos);
			return;
		}

		this.isCreatingLabel = true;

		const body = [
			{
				label: 'lbl_' + this.selectedLabel.id,
				portuguese: this.selectedLabel.portuguese,
				english: this.selectedLabel.english,
				spanish: this.selectedLabel.spanish,
				slovak: this.selectedLabel.slovak,
				chinese: this.selectedLabel.chinese,
				italian: this.selectedLabel.italian,
			},
		];

		this.LabelsService.postLabel(body).subscribe(
			() => {
				this.isCreatingLabel = false;
				this.crudType = 'update';
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
			},
			() => {
				this.NotificationService.setNotificationMessage('');
			}
		);
	}

	updateLabel(): void {
		if (this.isUpdatingLabel) return;

		if (!this.isAllFieldsFullfiled()) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos);
			return;
		}

		this.isUpdatingLabel = true;

		const body = {
			label: 'lbl_' + this.selectedLabel.id,
			portuguese: this.selectedLabel.portuguese,
			english: this.selectedLabel.english,
			spanish: this.selectedLabel.spanish,
			slovak: this.selectedLabel.slovak,
			chinese: this.selectedLabel.chinese,
			italian: this.selectedLabel.italian,
		};

		this.LabelsService.putLabel(body).subscribe(
			() => {
				this.isUpdatingLabel = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			},
			() => {
				this.NotificationService.setNotificationMessage('');
			}
		);
	}

	cleanForm(): void {
		this.selectedLabel = {
			id: this.selectedLabel.id,
			portuguese: '',
			english: '',
			spanish: '',
			slovak: '',
			chinese: '',
			italian: '',
		};
	}
}
